import React from 'react';
import { FaRegSmile } from "react-icons/fa";
import { FaRegFrown } from "react-icons/fa";
import CardOpen from "./CardOpen";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdOutlineNavigateNext } from "react-icons/md";

const Card = ({title, dimension, type, longDescription, show }) => {

  const [isOpen, setIsOpen] = React.useState(false);
  if (!show) return null;
  const handleClick = () => {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className={`bg-gray-100 hover:bg-gray-200 transition-colors shadow-xl border border-opacity-35 rounded-lg justify-center items-center text-center p-6 h-72 w-64 flex flex-col relative cursor-pointer`} onClick={handleClick}>
        <div className="absolute top-0 right-0 translate-x-1/3 -translate-y-1/3">
          <div className={`w-[100%] h-[100%] p-2 rounded-full flex justify-center items-center shadow-md ${type !== "Adequado" ? "bg-yellow-600" : "bg-emerald-700"}`}>
            {type !== "Adequado" ? <FaRegFrown className="text-3xl text-white" /> : <FaRegSmile className="text-3xl text-white" />}
          </div>
        </div>
        <div className='w-full'>
          <p className={`text-md font-medium text-start ${type !== "Adequado" ? "text-yellow-600" : "text-emerald-700"}`}>{title}</p>
        </div>
        <div className={`w-full h-[2px] mt-1 ${type !== "Adequado" ? "bg-yellow-600" : "bg-emerald-700"}`}></div>
        <div className={`p-3 mt-auto w-full rounded-lg ${type !== "Adequado" ? "bg-yellow-600" : "bg-emerald-700"}`}>
          <h2 className="font-semibold text-white text-xl uppercase drop-shadow-lg ">{type !== "Adequado" ? "Atenção" : "Adequado"}</h2>
        </div>
        <div className="flex text-sm justify-evenly items-center gap-2 w-full text-gray-600 mt-6">
          <IoMdInformationCircleOutline className="text-4xl"/>
          <p>Mais Informações</p>
          <MdOutlineNavigateNext className="text-4xl"/>
        </div>
      </div>
      {isOpen && <CardOpen open={isOpen} title={title} dimension={dimension} longDescription={longDescription} type={type} closeCard={handleClick} />}
    </>
  );
}

export default Card;
